import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderSupply extends BaseModelAPI {
	static entity = 'workordersupply';
	static entityName = 'workordersupply';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.workOrderProcessId = '';
		this.workOrderProcess = {};
		this.workOrderSupplyNumber = '';
		this.workOrderSupplyDate = '';
		this.remark = '';
		this.lineId = '';
		this.line = {};
		this.documentStatusId = '';
		this.documentStatus = {};
		this.workOrderSupplyDetail = []
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async printWoList(this_, wosNumber, id) {
		return await this_.$http.get(`${this.entityName}/printwoslist/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

}